import './style.scss'
import { useContext, useEffect, useState } from "react";
import VisibilityContext from 'src/provider/state-manager/visibilityProvider';
import ApiContext from 'src/provider/API/call-service';
import UserContext from 'src/provider/state-manager/userProvider';
import { AbsoluteContainer, AppSpan, AppText, Button, CustomContainer, FlexRow, Form, FormGroup, FormGroupWithIcon, GridContainer, ScreenTitle } from "src/style";
import { AppCenterPopupD2, CenterPopupHeaderD2, BillersD2, TxPinVerificationD2, AuthOtpD2, ConfirmBillPaymentD2 } from "src/component";
import { FiChevronDown } from "react-icons/fi";
import {handleAmountChange, moneyFormat} from 'src/utils/utility';
import { IExpenseCategory } from 'src/model';
import helpers from 'src/utils/helpers';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';

export const BillsPaymentD2: React.FC<any> =({billerCategories, selectedBillerCategory, back, close}) => {
    const {API} = useContext(ApiContext)
    const {notifier} = useContext(VisibilityContext)
    const {info: { institutionData }} = useContext(AppInfoContext);
    const {user: {accountInfo, accountWithBalanceDetails, dashboardData}} = useContext(UserContext)
    const [input, setInput] = useState({
        accountNumber: '', amount: '', billerCategoryID: selectedBillerCategory?.id, 
        billerCategoryName: selectedBillerCategory?.name, billerName: '', billerID: '', 
        paymentItemID: '', paymentItemCode: '', paymentItemName: '', customerUniqueCode: '',
        pin: '', expenseCategory: 'Bills and utilities'
    })
    const [selectedBiller, setSelectedBiller] = useState<any>(null)
    const [packages, setPackages] = useState<any>(null)
    const [selectedPackage, setSelectedPackage] = useState<any>(null)
    const [transactionReference, setTransactionReference] = useState('')
    const [expenseCategories, setExpenseCategories] = useState<IExpenseCategory[]>([])
    const [isLoading, setIsLoading] = useState(false)
    const [view, setView] = useState('bills-payment')
    const [amount,setAmount] = useState("")
    const paymentItemIsHidden = institutionData?.paymentItemIsHidden

    useEffect(() => {
        if (accountWithBalanceDetails?.length === 1 && accountWithBalanceDetails[0].nuban === null ) {
            setInput({...input, accountNumber: accountWithBalanceDetails[0].number})
        }else {
            setInput({...input, accountNumber: accountWithBalanceDetails[0].nuban})
    
        }
    }, [accountWithBalanceDetails])

    useEffect(() => {
        handleFetchExpenseCategories()
    }, [])

    async function handleFetchExpenseCategories() {
        setIsLoading(true)
        const response = expenseCategories?.length ? expenseCategories : await API.getExpenseCategories()
        setIsLoading(false)
        if (response) setExpenseCategories(response)
    }

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    const handleAmount = (e: React.ChangeEvent<HTMLInputElement>) => {
        let val = e.target.value.replace(/,/g, '')
        if (!isNaN(Number(val))) {
            setInput({...input, amount: val})
        }
    }

    async function handleBillerSelection (biller: any) {
        setSelectedBiller(biller)
        setInput({
            ...input, billerID: biller.billerID, billerName: biller.billerName, 
            amount: '', customerUniqueCode: '', paymentItemID: ''
        })
        
        setIsLoading(true)
        const response = await API.getPaymentPlans(biller.billerID)
        setIsLoading(false)
        if (response) setPackages(response)
    }

    useEffect(()=>{
        if(paymentItemIsHidden && packages){
            const firstBiller = packages[0]
            handlePackage(JSON.stringify(firstBiller))
        }
      },[paymentItemIsHidden,packages])

    function handlePackage (val: any) {
        val = JSON.parse(val)
        setSelectedPackage(val)
        setInput({
            ...input, paymentItemID: val.itemID, 
            amount: val.amount || '', paymentItemCode: val.code,
            paymentItemName: val.name, customerUniqueCode: ''
        })
    }

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        if (!input.billerCategoryName || !input.customerUniqueCode || !input.billerID) {
            return notifier.show('Kindly provide all information')
        } 

        setView('confirm-payment')
    }


    async function handleSubmit() {
        const accountTier = Number(helpers.getAccountDetailsWithAcctNo(dashboardData, input.accountNumber)?.accountBalance?.accountTier)
        const response = await API.initiateBillsPayment({...input, accountTier})
        if (response) {
            if (!response.shouldUseOtp) close()
            else {
                setTransactionReference(response.reference)
                setView('2fa-otp')
            }
        }
        else setView('bills-payment')
    }

    async function handleSubmitWithAuth (otp: string) {
        const response = await API.submitBillsPaymentWithAuth({otp, reference: transactionReference}) 
        
        if (response) close()
        else setView('bills-payment')
    }
    
    return (
        <>
            { view === 'bills-payment' &&
                <AppCenterPopupD2 height={input.billerID ? '76' : '56'} zIndex='6' overflow='hidden' close={close}>
                    <CenterPopupHeaderD2 title='Bills Payment' close={close} />
                    { (isLoading) &&
                        <AbsoluteContainer top='0' left='0' zIndex='3' width='100' sizeUnit='%' height="full">
                            <GridContainer height='100' hUnit="%" bgColor='rgba(255, 255, 255, 0.5)'>
                                <AppSpan textSize='4' color='#0D968F' className='fa fa-spinner fa-spin' />
                            </GridContainer>
                        </AbsoluteContainer>
                    }
                    <CustomContainer 
                        height={input.billerID ? '76' : '56'}
                        style={{maxHeight: '98%'}}
                        className="popup-content-container"
                    >
                        <Form 
                            onSubmit={handleProceed} topMargin='1.5'
                            style={{height: '86%'}}
                            className='overflow-y-container'
                        >
                            <FormGroupWithIcon>
                                <label>Biller Category</label>
                                <div className="input-with-icon disabled-input-wrapper">
                                    <select 
                                        name='billerCategoryID'
                                        value={input.billerCategoryID}
                                        style={{color: input.billerCategoryID ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        disabled
                                        required
                                    >
                                        <option value="">Select</option>
                                        {
                                            billerCategories?.map((item: any, index: number) => {
                                                return (
                                                    <option value={item.id} key={index}>{item.name}</option>
                                                )
                                            })
                                        }
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                            <FormGroupWithIcon>
                                <label>Biller</label>
                                <div className="input-with-icon" onClick={() => setView('billers')}>
                                    <GridContainer leftPadding='1.5' rightPadding='3.5' height='100' hUnit='%'>
                                        <AppText textSize='1.6' width='100' sizeUnit='%' color={input.billerName ? '#000000' : '#667085'}>
                                            {input.billerName || 'Select Biller'}
                                        </AppText>
                                    </GridContainer>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                            { input.billerID && !paymentItemIsHidden &&
                                <FormGroupWithIcon>
                                    <label>Package</label>
                                    <div className="input-with-icon">
                                        <select 
                                            value={JSON.stringify(selectedPackage)}
                                            style={{color: input.paymentItemID ? '#000000' : '#667085'}}
                                            onChange={(e) => handlePackage(e.target.value)}
                                            required ={!paymentItemIsHidden}
                                        >
                                            <option value="">Select Package</option>
                                            {
                                                packages?.map((item: any, index: number) => {
                                                    return (
                                                        <option key={index} value={JSON.stringify(item)}>{item.name} {item.amount != 0 && `- ${moneyFormat(item.amount,false,institutionData?.defaultCurrency)}`}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                        <FiChevronDown className="input-with-icon-tag" />
                                    </div>
                                </FormGroupWithIcon>
                            }
                            { input.billerID &&
                                <FormGroup>
                                    <label>{selectedBiller?.customerFieldOne || 'Customer Id'}</label>
                                    <input 
                                        placeholder={`Enter ${selectedBiller?.customerFieldOne || 'Customer Id'}`}
                                        name='customerUniqueCode'
                                        value={input.customerUniqueCode}
                                        onChange={handleInput}
                                        autoComplete="off"
                                        required
                                    />
                                </FormGroup>
                            }
                            { selectedPackage &&
                                <FormGroup>
                                    <label>Amount</label>
                                    <input 
                                        placeholder='Enter Amount' 
                                        name='amount'
                                        autoComplete='off'
                                        value={selectedPackage?.amount || amount}
                                        onChange={(e) => handleAmountChange(e.target.value, "input",setAmount, setInput, input,e.target.name)}
                                        disabled={selectedPackage?.amount}
                                        required
                                    />
                                </FormGroup>
                            }

                            { !paymentItemIsHidden && <FormGroupWithIcon bottomMargin='2'>
                                <label>Expense Category</label>
                                <div className="input-with-icon">
                                    <select 
                                        placeholder="Select Expense Category"
                                        name='expenseCategory'
                                        value={input.expenseCategory}
                                        style={{color: input.expenseCategory ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        //required
                                    >
                                        <option value="Select">Select Category</option>
                                        {
                                            expenseCategories?.map((item: IExpenseCategory, index: number) => {
                                                return <option value={item.name} key={index}>{item.name}</option>
                                            })
                                        }
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                            }
                            <FormGroupWithIcon>
                                <label>Account</label>
                                <div className="input-with-icon">
                                    <select 
                                        name='accountNumber'
                                        value={input.accountNumber}
                                        style={{color: input.accountNumber ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        disabled={accountWithBalanceDetails?.length === 1}
                                        required
                                    >
                                        <option value="">Select Account</option>
                                        {
                                            accountWithBalanceDetails?.map((item: any, index: number) => {
                                                const accountIdentifier = item.nuban || item.number;
                                                return (
                                                    <option 
                                                        value={accountIdentifier} 
                                                        key={index}
                                                    >
                                                        {accountIdentifier} - ({moneyFormat(item?.balance?.withdrawableAmount,false,institutionData?.defaultCurrency)})
                                                    </option>
                                                )
                                            })
                                        }
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                            
                            <FlexRow justifyContent='flex-end' gap="1.5" topMargin="2.5">
                                <Button 
                                    width='50' sizeUnit="%" height='4.4' bgColor="#ffffff"
                                    borderColor='#D0D5DD' hoverBgColor='#ffffff' 
                                    hoverColor='#0D968F' titleSize='1.4' color="#344054"
                                    onClick={back}
                                >
                                    Back
                                </Button>
                                <Button 
                                    width='50' sizeUnit="%" height='4.4' 
                                    borderColor='#0D968F' hoverBgColor='#ffffff' 
                                    hoverColor='#0D968F' titleSize='1.4'
                                >
                                    Proceed
                                </Button>
                            </FlexRow>
                        </Form>   
                    </CustomContainer>
                </AppCenterPopupD2>
            }
            { view === 'pin' &&
                <TxPinVerificationD2
                    close={close}
                    onPinChange={(pin: string) => setInput({...input, pin})}
                    next={handleSubmit} 
                />
            }
            { view === 'billers' &&
                <BillersD2
                    close={() => setView('bills-payment')}
                    back={() => setView('bills-payment')} // to be use if we later have back button
                    updateData={handleBillerSelection}
                    categoryId={selectedBillerCategory?.id}
                />
            }
            { view === 'confirm-payment' &&
                <ConfirmBillPaymentD2
                    close={close}
                    data={input} 
                    next={() => setView('pin')}
                    back={() => setView('bills-payment')}
                />
            }
            { view === '2fa-otp' &&
                <AuthOtpD2
                    close={close}
                    next={handleSubmitWithAuth} 
                />
            }
        </>
    )
}